import { Component, OnDestroy, OnInit } from '@angular/core';

import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { PlayersFacade } from '../../+store/players.facade';

@Component({
    selector: 'app-player-search',
    templateUrl: './player-search.component.html',
    styleUrls: ['./player-search.component.scss'],
    standalone: false
})
export class PlayerSearchComponent implements OnInit, OnDestroy {
    player$ = this.playerFacade.player$;
    players$ = this.playerFacade.players$;
    selectedPlayer$ = this.playerFacade.selectedPlayer$;

    form: UntypedFormGroup;

    subscription: Subscription = new Subscription();
    constructor(private playerFacade: PlayersFacade, private formBuilder: UntypedFormBuilder) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            search: [null]
        });
        this.initFormSubscription();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    initFormSubscription() {
        this.subscription.add(
            this.form.controls.search.valueChanges.pipe(debounceTime(1000)).subscribe(value => {
                this.playerFacade.searchPlayers(value);
            })
        );
    }
}
